import script from "./SoundMixin.vue?vue&type=script&lang=ts"
export * from "./SoundMixin.vue?vue&type=script&lang=ts"

export default script